import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import usePlan from '../hooks/usePlan';

const PaymentReminderStripe = ({ 
  onDismiss, 
  onPayNow, 
  className = "" 
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastDismissedTime, setLastDismissedTime] = useState(null);
  const location = useLocation();
  const { 
    plan: planData, 
    isPaid, 
    isExpired, 
    isDue, 
    isFree, 
    statusMessage, 
    shouldShowStripe,
    stripeColor
  } = usePlan();

  const handleDismiss = () => {
    setIsVisible(false);
    setLastDismissedTime(Date.now());
    if (onDismiss) onDismiss();
  };

  const handlePayNow = () => {
    if (onPayNow) onPayNow();
  };

  // Check if 10 minutes have passed since last dismissal
  const shouldShowAgain = () => {
    if (!lastDismissedTime) return true;
    const tenMinutesInMs = 10 * 60 * 1000; // 10 minutes in milliseconds
    return Date.now() - lastDismissedTime >= tenMinutesInMs;
  };

  // Show stripe again on route change or after 10 minutes
  useEffect(() => {
    if ((shouldShowStripe && planData )|| shouldShowAgain()) {
      setIsVisible(true);
    }
  }, [location.pathname, shouldShowStripe, planData]);

  // Check every minute if 10 minutes have passed
  useEffect(() => {
    if (!isVisible && lastDismissedTime) {
      const interval = setInterval(() => {
        if (shouldShowAgain()) {
          setIsVisible(true);
        }
      }, 60000); // Check every minute

      return () => clearInterval(interval);
    }
  }, [isVisible, lastDismissedTime]);

  if (!isVisible || !planData || !shouldShowStripe) return null;

  const isUrgent = planData?.isUrgent;

  return (
    <div 
      className={`payment-reminder-stripe ${className} ${isUrgent ? 'urgent' : ''}`}
      data-plan-type={planData.planType}
      data-status={planData.status}
      data-color={stripeColor}
    >
      <div className="payment-reminder-stripe-content">
        <div className="payment-reminder-stripe-icon">
          {planData.statusIcon && <planData.statusIcon className="w-5 h-5" />}
        </div>
        
        <div className="payment-reminder-stripe-text">
          <span className="font-semibold">
            {statusMessage || "No plan information available"}
          </span>
        </div>
        
        <div className="payment-reminder-stripe-actions">
          {(isDue || isExpired || isFree) && (
            <span className="payment-reminder-stripe-contact">
              Contact Admin
            </span>
          )}
          
          <button 
            onClick={handleDismiss}
            className="payment-reminder-stripe-dismiss"
            title="Dismiss"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentReminderStripe;
